<template>
  <div class="page--home">
    <v-container fluid>
      <v-row class="mt-8">
        <v-col>
          <CalendarioAnualFormacoes
            :ano="anoCalendario"
            :eventos="eventosCalendario"
            :coresPorTipo="coresPorTipo"
            :mesInicio="mesInicio"
            :mesFinal="mesFinal"
            :anosDisponiveis="anosDisponiveis"
            @abrirMes="irParaMes"
          />
        </v-col>
      </v-row>
    </v-container>

    <ConfirmarFormacaoDialog
      v-if="user.formacoesPendentes?.length"
      :dialogVisivel="true"
      :formacoes="user.formacoesPendentes"
      :usuario="user"
      @onClose="() => {}"
    />
    <DialogFormacoesDoMes
      :visible="dialogFormacoesMes.visible"
      :formacoes="dialogFormacoesMes.formacoes"
      :mes="dialogFormacoesMes.mes"
      :ano="dialogFormacoesMes.ano"
      @onClose="dialogFormacoesMes.visible = false"
    />
  </div>
</template>

<script>
import pageLoadingMixin from "mixins/page-loading.mixin";
import configurations from 'commons/configurations';
import { AUTH_NAMESPACE, USER, ABILITIES, MENU } from 'store/modules/auth';
import ConfirmarFormacaoDialog from '@/views/post-login/ConfirmarPresencaDialog.vue';
import CalendarioAnualFormacoes from '@/components/CalendarioAnualFormacoes.vue';
import DialogFormacoesDoMes from '@/views/post-login/DialogFormacoesDoMes.vue';
export default {
  name: "Home",
  mixins: [pageLoadingMixin],
  components: { ConfirmarFormacaoDialog, CalendarioAnualFormacoes, DialogFormacoesDoMes },

  data: () => ({
    mostrarDialogFormacao: false,
    app: { name: configurations.app.name, alias: configurations.app.alias },

    anoCalendario: new Date().getFullYear(),
    mesInicio: 1,
    mesFinal: 12,
    anosDisponiveis: [],
    eventosCalendario: [],
    coresPorTipo: {},
    dialogFormacoesMes: {
      visible: false,
      formacoes: [],
      mes: null,
      ano: null
    }
  }),

  computed: {
    user() {
      return {
        ...this.$store.getters[`${AUTH_NAMESPACE}/${USER}`],
        permissions: this.$store.getters[`${AUTH_NAMESPACE}/${ABILITIES}`],
        menu: this.$store.getters[`${AUTH_NAMESPACE}/${MENU}`]
      }
    },
    permissoes() {
      return this.$store.getters[`${AUTH_NAMESPACE}/${ABILITIES}`];
    },
  },

  watch: {
    anoCalendario: {
      immediate: true,
      handler() { this.carregarCalendario() }
    }
  },

  methods: {
    verificacaoPermissaoTermo() {
      if (this.user.changePassword) return this.$router.push('/trocar-senha');
      const rota = this.user.acceptedTerms ? '/app' : '/consentimento-uso-de-dados-pessoais';
      this.$router.push(rota).catch(() => {});
    },

    irParaMes({ ano, mes }) {
      this.dialogFormacoesMes = {
        visible: true,
        formacoes: [],
        mes: mes,
        ano: ano
      };
    },
    async carregarCalendario() {
      this.showPageLoading();
      try {
        const { data } = await this.$buscarCalendarioPaginaInicial();
        const lista = Array.isArray(data?.lista) ? data.lista : [];
        const { eventos, cores, anosDisponiveis, primeiroAno } = this.mapearPayload(lista);
        this.eventosCalendario = eventos;
        this.coresPorTipo = cores;  
        const anoAtual = new Date().getFullYear();
        if (anosDisponiveis.length) {
          this.anosDisponiveis = anosDisponiveis;      
          this.anoCalendario = anosDisponiveis.includes(anoAtual) 
            ? anoAtual 
            : (primeiroAno || anoAtual);
        } else {
          this.anosDisponiveis = [anoAtual];
          this.anoCalendario = anoAtual;
          this.eventosCalendario = [];
        }
      } catch (err) {    
        const anoAtual = new Date().getFullYear();
        this.anosDisponiveis = [anoAtual];
        this.anoCalendario = anoAtual;
        this.eventosCalendario = [];
        this.coresPorTipo = {};    
        this.$notifyError("Não foi possível carregar o calendário de formações");
      } finally {
        this.hidePageLoading();
      }
    },

    mapearPayload(listaAnos) {
      const eventos = [];
      const cores = {};
      const anosDisponiveis = [];
      let primeiroAno = null;
      const toCanonical = (t) => {
        const v = String(t || '').toLowerCase();
        if (v === 'see' || v === 'secretaria' || v === 'estado') return 'SEE';
        if (v === 'gre') return 'GRE';
        return 'Escola';
      };
      for (const anoObj of listaAnos) {
        if (anoObj?.ano) {
          const ano = parseInt(anoObj.ano, 10);
          if (!isNaN(ano)) {
            anosDisponiveis.push(ano);
            if (!primeiroAno || ano < primeiroAno) primeiroAno = ano;
          }          
          if (Array.isArray(anoObj?.lista)) {
            for (const item of anoObj.lista) {
              const tipoCanon = toCanonical(item?.tipo);
              if (item?.cor) cores[tipoCanon] = item.cor;
              const dIni = new Date(item?.dataInicio);
              const dFim = new Date(item?.dataFim);
              if (isNaN(+dIni) || isNaN(+dFim)) continue;
              for (let d = new Date(dIni); d <= dFim; d.setDate(d.getDate() + 1)) {
                const yyyy = d.getFullYear();
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                eventos.push({ date: `${yyyy}-${mm}-${dd}`, tipo: tipoCanon });
              }
            }
          }
        }
      }
      anosDisponiveis.sort((a, b) => a - b);
      return { eventos, cores, anosDisponiveis, primeiroAno };
    },
  },

  mounted() {
    this.verificacaoPermissaoTermo();
    if (this.user.formacoesPendentes?.length) this.mostrarDialogFormacao = true;
  }
};
</script>

